import { FC } from "react";
import { Stack } from "@mui/material";
import { CoverageWidgetHeaderInfoProps } from "@/components/pages/dashboard/components/widgets/coverage/components/header/CoverageWidgetHeaderInfo";
import { WidgetCardHeaderEditButton } from "@/components/pages/dashboard/components/widgets/common/widget-header/components/WidgetCardHeaderEditButton";
import { CoverageWidgetCardHeaderTypeSelect } from "@/components/pages/dashboard/components/widgets/coverage/components/header/CoverageWidgetCardHeaderTypeSelect";
import { CoverageWidgetCardHeaderGroupBySelect } from "@/components/pages/dashboard/components/widgets/coverage/components/header/CoverageWidgetCardHeaderGroupBySelect";
import { CoverageWidgetCardHeaderDateSelect } from "@/components/pages/dashboard/components/widgets/coverage/components/header/CoverageWidgetCardHeaderDateSelect";

interface CoverageWidgetCardSubHeaderProps
  extends CoverageWidgetHeaderInfoProps {
  widgetId?: string;
}

export const CoverageWidgetCardSubHeader: FC<
  CoverageWidgetCardSubHeaderProps
> = ({
  commitmentType,
  providerOrganisationId,
  dates,
  grouping,
  widgetId,
  provider,
}) => {
  return (
    <Stack direction="row" gap={1} alignItems="center" overflow="auto">
      {(providerOrganisationId || provider) && (
        <CoverageWidgetCardHeaderTypeSelect
          widgetId={widgetId}
          provider={provider}
          commitmentType={commitmentType}
          providerOrganisationId={providerOrganisationId}
        />
      )}

      {grouping && (
        <CoverageWidgetCardHeaderGroupBySelect
          widgetId={widgetId}
          grouping={grouping}
        />
      )}

      {dates && (
        <CoverageWidgetCardHeaderDateSelect dates={dates} widgetId={widgetId} />
      )}

      {widgetId && (
        <WidgetCardHeaderEditButton widgetId={widgetId} widgetType="coverage" />
      )}
    </Stack>
  );
};
